import React, { useState } from "react";
import {
  useAppDispatch,
  useAppSelector,
  selectMessagesStatus,
  sendMessage,
} from "../../store";

import "./ContactForm.scss";

function LoadingIndicator() {
  return <div className="loading-container">LOADING...</div>;
}

const msgMinLen = 80;

type Props = {};
function ContactForm(props: Props) {
  const [senderName, setSenderName] = useState("");
  const [senderEmailAdd, setSenderEmailAdd] = useState("");
  const [message, setMessage] = useState("");
  const messagesStatus = useAppSelector(selectMessagesStatus);
  const dispatch = useAppDispatch();

  return (
    <div className="contact-form-container">
      <form
        className="form"
        // method="POST"
        // action={`${process.env.REACT_APP_BACKEND_URL}/messages`}
        onSubmit={(ev) => {
          dispatch(sendMessage({ message, senderEmailAdd, senderName }));
          ev.preventDefault();
        }}
      >
        <label htmlFor="name">
          <span>Name</span>
          <input
            id="name"
            name="senderName"
            value={senderName}
            onChange={(ev) => setSenderName(ev.target.value)}
            placeholder="Name"
            type="text"
            minLength={1}
            required
          />
        </label>

        <label htmlFor="email-address">
          <span>E-Mail Address</span>
          <input
            id="email-address"
            name="senderEmailAddress"
            placeholder="Email Address"
            value={senderEmailAdd}
            onChange={(ev) => setSenderEmailAdd(ev.target.value.trim())}
            type="email"
            required
          />
        </label>

        <label htmlFor="message">
          <span>Message</span>
          <textarea
            id="message"
            name="message"
            placeholder="Message"
            value={message}
            onChange={(ev) => setMessage(ev.target.value)}
            minLength={msgMinLen}
            required
          />
          <div className="foot">({msgMinLen} CHARACTERS MININUM)</div>
        </label>
        <div className="button-group">
          <button className="positive">SEND</button>
          <button
            className="negative"
            onClick={(ev) => {
              setMessage("");
              setSenderEmailAdd("");
              setSenderName("");
              ev.preventDefault();
            }}
          >
            CLEAR
          </button>
        </div>
        {messagesStatus === "pending" && <LoadingIndicator />}
      </form>
    </div>
  );
}
export { ContactForm as default };
